<template>
  <div class="flex items-center w-full">
    <div class="bg-grey-light w-full h-2 rounded-full overflow-hidden mr-1">
      <div class="bg-green progress h-full" :style="getStyles"></div>
    </div>
    <slot v-if="showPercentage"> {{ progress }}% </slot>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true,
    },
    showPercentage: {
      type: Boolean,
      default: true,
    },
    styles: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    getStyles() {
      return { ...this.styles, width: `${this.progress}%` }
    },
  },
}
</script>

<style scoped>
.progress {
  transition: width 0.3s ease-in-out;
}
</style>
